import { useTheme } from "@/design-system/theme/useTheme";
import { useTranslation } from "react-i18next";
import { NavbarActionToggle } from "./NavbarActionToggle";
import { ThemeToggleButtonProps } from "./types";
import { MoonIcon, SunIcon } from "@heroicons/react/24/outline";

/**
 * 主題切換按鈕組件
 * 允許用戶在深色和添色模式之間切換
 */
export function ThemeToggleButton({
  className = "",
}: ThemeToggleButtonProps = {}) {
  const { isDarkMode, toggleTheme } = useTheme();
  const { t } = useTranslation();

  const ariaLabel = isDarkMode
    ? t("theme.switchToLight")
    : t("theme.switchToDark");
  const title = isDarkMode ? t("theme.switchToLight") : t("theme.switchToDark");

  return (
    <NavbarActionToggle
      onClick={toggleTheme}
      ariaLabel={ariaLabel}
      title={title}
      className={className}
    >
      {isDarkMode ? (
        <SunIcon className="w-4 h-4" />
      ) : (
        <MoonIcon className="w-4 h-4" />
      )}
    </NavbarActionToggle>
  );
}
